// extracted by mini-css-extract-plugin
module.exports = {"root":"Calender-module__root__2DItH","month-yy":"Calender-module__month-yy__YkE4X","dd-mm-yyyy":"Calender-module__dd-mm-yyyy__1dJe6"};